import { ConvexReactClient } from "convex/react";

const convexUrl = (import.meta.env.VITE_CONVEX_URL as string).replace(/\/+$/, "");
const options = { skipConvexDeploymentUrlCheck: true };

export const publicConvexClient = new ConvexReactClient(convexUrl, options);
export const authConvexClient = new ConvexReactClient(convexUrl, {
  ...options,
  expectAuth: true,
});
